"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCheckoutLineItemsForDeliveryPath = exports.getCheckoutLineItemsForDelivery = void 0;
const utils_1 = require("@invivodf/utils");
const utils_2 = require("../../../utils");
const getCheckoutLineItemsForDelivery = (client) => async ({ checkoutId }) => {
    try {
        const response = await client.get((0, exports.getCheckoutLineItemsForDeliveryPath)(checkoutId));
        return utils_1.Result.success(response.data);
    }
    catch (error) {
        if ((0, utils_2.isFunctionalApiError)(error)) {
            return utils_1.Result.failure({
                code: error.body.code,
                message: error.body.message
            });
        }
        throw error;
    }
};
exports.getCheckoutLineItemsForDelivery = getCheckoutLineItemsForDelivery;
const getCheckoutLineItemsForDeliveryPath = (checkoutId) => `/v2/bff/appro/checkouts/${checkoutId}/line-items/for-delivery`;
exports.getCheckoutLineItemsForDeliveryPath = getCheckoutLineItemsForDeliveryPath;
